import React from "react";

type Props = { isOpen: boolean; onOpen: () => void };

function PortalPCResearchBar({ isOpen, onOpen }: Props) {
  return (
    <div id="jsPortalPcResearchBtn" className="portalPcResearchBar">
      <div className="portalPcResearchBarBand">
        <button
          type="button"
          aria-haspopup="dialog"
          aria-expanded={isOpen}
          onClick={(e) => {
            // NOTE: マウス操作ではボタンにフォーカスが乗らないまま開くことがあり、閉じた後の戻り先が body になる。
            //       ダイアログ側は開く直前の activeElement に戻すため、ここで明示的にフォーカスしておく
            e.currentTarget.focus();
            onOpen();
          }}
        >
          <span className="portalPcResearchBarTitle">
            <i className="fa fa-search" aria-hidden="true" />
            検索条件を変更する
          </span>
          <span className="portalPcResearchBarNote">
            募集の絞り込みを再設定できます
          </span>
        </button>
      </div>
    </div>
  );
}

export default PortalPCResearchBar;
